const NewsLetter = () => {
  return (
    <section>
      <div className="container my-10">
        <div className="grid gap-20 rounded-md bg-slate-100 py-14 px-6 text-slate-900 shadow dark:bg-slate-800 dark:text-white lg:grid-cols-2">
          <div>
            <h2 className="text-3xl font-extrabold tracking-tight">Join us for our newsletter</h2>
            <p className="mt-4 text-lg text-slate-500">
              Join us for our newsletter and stay up-to-date on the latest developments in the
              exciting world of robotics!
            </p>
          </div>
          <div className="grid place-items-center">
            <form className="sm:flex">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email-address"
                type="email"
                autoComplete="email"
                required
                className="w-full grow rounded-md border-white px-5 py-3 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-700"
                placeholder="Enter your email"
              />
              <button
                type="submit"
                className="mt-3 flex w-full items-center justify-center rounded-md border border-transparent bg-slate-500 px-5 py-3 text-base font-medium text-white hover:bg-slate-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-700 sm:mt-0 sm:ml-3 sm:w-auto sm:flex-shrink-0"
              >
                Notify me
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
export default NewsLetter;
